import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import './LoginForm.css';
import {
  IonInput,
  IonItem,
  IonButton,
  IonSpinner,
  IonText,
} from '@ionic/react';
import {
  getAuthEmail,
  storeAuthEmail,
} from '../../../../domains/auth/AuthSagas';

const MyInput = ({ field, form, ...props }: any) => {
  return <IonInput {...field} {...props} onIonChange={field.onChange} />;
};

type Values = {
  email: string;
  password: string;
};

interface IProps {
  onSubmit: (values: Values) => any;
  showLoader: boolean;
}

class LogingForm extends PureComponent<IProps> {
  state = {
    initialEmail: getAuthEmail(),
  };

  validate = (values: Values) => {
    const errors: { [key: string]: string } = {};
    if (!values.email) {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    if (!values.password) {
      errors.password = 'Required';
    }
    return errors;
  };

  onSubmit = (values: Values, { resetForm }: any) => {
    storeAuthEmail(values.email);
    this.props.onSubmit(values);
    resetForm();
  };

  render() {
    const { initialEmail } = this.state;
    const { showLoader } = this.props;
    return (
      <div className="LoginForm-container">
        <Formik
          initialValues={{
            email: initialEmail,
            password: 'password',
          }}
          validate={this.validate}
          onSubmit={this.onSubmit}
        >
          {({ isSubmitting, submitCount, resetForm }) => (
            <Form>
              <IonItem>
                <Field type="email" name="email" component={MyInput} />
                <ErrorMessage name="email">
                  {(msg) =>
                    !!submitCount && (
                      <>
                        <IonText color="danger">{msg}</IonText>
                      </>
                    )
                  }
                </ErrorMessage>
              </IonItem>
              <IonItem>
                <Field
                  type="password"
                  name="password"
                  component={MyInput}
                  placeholder="Password"
                />
                <ErrorMessage name="password">
                  {(msg) =>
                    !!submitCount && (
                      <>
                        <IonText color="danger">{msg}</IonText>
                      </>
                    )
                  }
                </ErrorMessage>
              </IonItem>

              <br />
              <br />
              <IonButton
                type="submit"
                disabled={isSubmitting || showLoader}
                color="dark"
              >
                {showLoader ? <IonSpinner /> : 'Sign In'}
              </IonButton>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default LogingForm;
